import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  compose,
  lifecycle,
  branch,
  renderNothing,
  withHandlers,
  withState,
} from 'recompose'

import {
  fetchCalendarStatus,
  updateMeetingType,
  fetchGoogleScopes,
  fetchMeetingSettings,
  updateMeetingSettings,
  disconnectGoogleCalendar,
  disconnectMicrosoftCalendar,
  fetchMicrosoftAdminConsent,
  fetchMeetingTypes,
} from 'app/modules/meetings/actions'

import { hasMeetings, hasBetaGlobalCalendars, isOnFreePlan } from 'app/modules/gates/selectors'
import {
  getIsGoogleOauthConnected as isGoogleAuthed,
  getIsMicrosoftOauthConnected as isMicrosoftAuthed,
  getCalendar,
  getCalendarStatusLoaded,
  getCalendarStatusPending,
  getDefaultMeetingType,
  hasCalendarScope,
  hasEmailScope,
  isMeetingSettingsLoaded,
  getIsTokenRevoked,
  hasMicrosoftAdminConsent,
  isFetchMicrosoftAdminConsentLoaded,
  getMeetingTypes,
  isMeetingTypesLoaded
} from 'app/modules/meetings/selectors'
import { currentUser } from 'app/modules/user/selectors'

import CalendarSettings from './component'

function makeMapStateToProps() {
  return state => ({
    hasCalendarScope: hasCalendarScope(state),
    hasEmailScope: hasEmailScope(state),
    isGoogleAuthed: isGoogleAuthed(state),
    isMicrosoftAuthed: isMicrosoftAuthed(state),
    isTokenRevoked: getIsTokenRevoked(state),
    calendar: getCalendar(state),
    isCalendarPending: getCalendarStatusPending(state),
    isCalendarLoaded: getCalendarStatusLoaded(state),
    isSettingsLoaded: isMeetingSettingsLoaded(state),
    currentUser: currentUser(state),
    meetingSettings: getDefaultMeetingType(state),
    hasMeetings: hasMeetings(state),
    hasBetaGlobalCalendars: hasBetaGlobalCalendars(state),
    isGlobalCalendarManaged: hasMicrosoftAdminConsent(state),
    isGlobalAdminConsentLoaded: isFetchMicrosoftAdminConsentLoaded(state),
    isOnFreePlan: isOnFreePlan(state),
    meetingTypes: getMeetingTypes(state),
    isMeetingTypesLoaded: isMeetingTypesLoaded(state),
  })
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchCalendarStatus,
        updateMeetingType,
        fetchGoogleScopes,
        fetchMeetingSettings,
        updateMeetingSettings,
        disconnectGoogleCalendar,
        disconnectMicrosoftCalendar,
        fetchMicrosoftAdminConsent,
        fetchMeetingTypes,
      },
      dispatch
    ),
  }
}
export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (!this.props.isCalendarLoaded || !this.props.isSettingsLoaded || !this.props.isMeetingTypesLoaded) {
        this.props.actions.fetchCalendarStatus()
        this.props.actions.fetchGoogleScopes()
        this.props.actions.fetchMeetingSettings()
        this.props.actions.fetchMicrosoftAdminConsent()
        this.props.actions.fetchMeetingTypes()
      }
    },
  }),
  withState('isCreatingNew', 'setIsCreatingNew', false),
  withState('isUpgradeModalOpen', 'setUpgradeModal', false),
  withState('activeTab', 'setActiveTab', 0),
  withHandlers({
    handleCreateMeetingType: props => () => {
      props.setIsCreatingNew(true)
      setTimeout(() => {
        props.router.push('/settings/calendar/edit/new')
      }, 400)
    },
    handleGoogleCalendarScopeAdded: props => () => {
      props.actions.fetchGoogleScopes()
    },
    handleDisconnectCalendar: ({ isGoogleAuthed, actions }) => () => {
      isGoogleAuthed ? actions.disconnectGoogleCalendar() : actions.disconnectMicrosoftCalendar()
    },
  }),
  branch(({ isCalendarLoaded, isSettingsLoaded, isGlobalAdminConsentLoaded }) => !isCalendarLoaded || !isSettingsLoaded || !isGlobalAdminConsentLoaded, renderNothing),
  lifecycle({
    componentDidMount() {
      const { meetingSettings, isGoogleAuthed, isMicrosoftAuthed, isGlobalCalendarManaged, actions } = this.props
      // if allowNewAppointments if false while customer is connected they're in a bad state.
      // So enable it, pronto. This is > a clumsy settings backfill. - pk2
      if (!meetingSettings.allowNewAppointments && (isGoogleAuthed || isMicrosoftAuthed || isGlobalCalendarManaged)) {
        actions.updateMeetingSettings(meetingSettings.set('allowNewAppointments', true))
      }
    },
    componentWillReceiveProps(nextProps) {
      if (!(nextProps.calendar && nextProps.calendar.id)) {
        nextProps.router.replace('/settings/calendar/connect')
      }
    }
  })
)(CalendarSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/index.js